import React from 'react';
import styled from 'styled-components';
import { MainTitle, Description } from '../components/Atoms/Texts';
import { Spacing } from '../components/Atoms/Dividers';

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width:100%;
    min-height: 500px;
    height: 70vh;
`;

const NotFoundPage = () => (
	<Wrapper>
		<MainTitle>Page not found</MainTitle>
		<Spacing />
		<Description textAlign="center">The page you are looking for has beed removed or relocated.</Description>
	</Wrapper>
);

export default NotFoundPage;
